document.addEventListener("DOMContentLoaded", function() {
  // 外部ドメインに対して別窓設定を付与する
  let links = document.links;

  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'external';
    }

    // 商品名に改行を追加
    document.querySelectorAll("a[href*='compression-socks']").forEach(function(element) {
            
      if (
        element.textContent.includes("MAEÉ　コンプレッションソックス") &&
        !element.textContent.includes("くつしたの日")) // 限定商品対応
      {
        console.log(element);
        let modifiedText = element.textContent
            .replace("　", " ") // 1) 全角スペースを半角スペースに変換
            .replace(/）.+$/, "）")
            .replace("コンプレッションソックス（", "コンプレッションソックス<br>（"); // 2) <br>タグを挿入
        
        element.innerHTML = modifiedText; // 3) ソースへ反映
      }
    });
    
    // 商品名に改行を追加（商品詳細ページ）
    const socks_page = document.querySelector('.compression_socks');

    if(socks_page) {
      const product_title_element = document.querySelector('.product-info__block-item .product-title.h5');
      // const modified_product_title_element = product_title_element.textContent

      if (
        product_title_element &&
        !product_title_element.textContent.includes("くつしたの日") // 限定商品対応
      ) {
        const modified_product_title_element = product_title_element.textContent
            .replace("　", " ")
            .replace(/）.+$/, "）")
            .replace("コンプレッションソックス（", "コンプレッションソックス<br>（");

        product_title_element.innerHTML = modified_product_title_element;
      }
    }

    const compression_page = document.querySelector('.compression');
    if(compression_page) {
      const product_title_element = document.querySelector('.product-info__block-item .product-title.h5');
      // const modified_product_title_element = product_title_element.textContent

      if (
        product_title_element &&
        !product_title_element.textContent.includes("くつしたの日") // 限定商品対応
      ) {
        const modified_product_title_element = product_title_element.textContent
            .replace("　", " ")
            .replace(/）.+$/, "）")
            .replace("（", "<br>（");

        product_title_element.innerHTML = modified_product_title_element;
      }
    }
  };

  // FAQのコンテンツ制御
  const elements = document.querySelectorAll("accordion-disclosure");
  if (elements.length === 0)  {
    console.log('no accordion-disclosure')
   return; 
  } else {
    elements.forEach((element, index) => {
        element.id = `acc_disclosure${String(index).padStart(2, '0')}`;
    });
  }
});

// ↓ ギフトボックス
const GIFT_PRODUCT_HANDLE = 'giftbox_xxx';

// ギフトボックスの数量を1に強制する関数
async function ensureGiftBoxQuantityIsOne() {
  const cart = await fetch('/cart.js').then(res => res.json());
  const giftItem = cart.items.find(item => item.handle === GIFT_PRODUCT_HANDLE);
  
  if (giftItem && giftItem.quantity > 1) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: {
          [giftItem.key]: 1
        }
      })
    });
    return true;
  }
  return false;
}

// チェックボックスのクリックイベント
document.addEventListener('click', async function (e) {
  const toggle = e.target.closest('#giftbox-toggle');
  if (!toggle) return;

  const cart = await fetch('/cart.js').then(res => res.json());
  const giftItem = cart.items.find(item => item.handle === GIFT_PRODUCT_HANDLE);

  const variantId = document.querySelector('#giftbox-form [name="id"]')?.value;
  if (!variantId) {
    console.error('ギフトボックスの variant ID が取得できません');
    return;
  }

  if (toggle.checked) {
    if (giftItem) {
      if (giftItem.quantity !== 1) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: {
              [giftItem.key]: 1
            }
          })
        });
        document.dispatchEvent(new Event('cart:refresh'));
      }
      return;
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    });

    document.dispatchEvent(new Event('cart:refresh'));
    return;
  }

  if (!toggle.checked && giftItem) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: {
          [giftItem.key]: 0
        }
      })
    });

    document.dispatchEvent(new Event('cart:refresh'));
  }
});

// 決済ボタンのクリックをインターセプト
document.addEventListener('click', async function (e) {
  const checkoutButton = e.target.closest('[name="checkout"], [type="submit"][value="checkout"], a[href="/checkout"], button[name="checkout"], .shopify-payment-button button, [data-shopify="payment-button"] button');
  
  if (!checkoutButton) return;

  e.preventDefault();
  e.stopPropagation();

  const wasUpdated = await ensureGiftBoxQuantityIsOne();
  
  if (wasUpdated) {
    document.dispatchEvent(new Event('cart:refresh'));
  }

  window.location.href = '/checkout';
}, true);

// フォームのsubmitもインターセプト
document.addEventListener('submit', async function (e) {
  const form = e.target;
  if (!form.action || !form.action.includes('/checkout')) return;

  e.preventDefault();

  await ensureGiftBoxQuantityIsOne();
  
  form.submit();
}, true);
// ↑ ギフトボックス

(function () {
  const TARGET_HREF_PART = "compression-socks";
  const TARGET_TEXT = "コンプレッションソックス";
  const PROCESSED_FLAG = "data-compression-socks-processed";

  function transformAnchor(a) {
    if (!a || a.getAttribute(PROCESSED_FLAG) === "1") return;
    if (!a.href || !a.href.includes(TARGET_HREF_PART)) return;
    if (!a.textContent || !a.textContent.includes(TARGET_TEXT)) return;

    const modifiedText = a.textContent
      .replace(/　/g, " ")         // 全角スペース→半角スペース（複数想定でg）
      .replace(/）.+$/, "）")       // 全角カッコ閉じ以降をトリム
      .replace(TARGET_TEXT + "（", TARGET_TEXT + "<br>（"); // 改行挿入

    a.innerHTML = modifiedText;
    a.setAttribute(PROCESSED_FLAG, "1");
  }

  // 初期DOM（ロード済み分）に適用
  function applyToExisting() {
    document.querySelectorAll(`a[href*='${TARGET_HREF_PART}']`).forEach(transformAnchor);
  }

  // 追加・更新DOMに適用
  function observeDynamic() {
    const pending = new Set();
    let rafId = null;

    function scheduleProcess() {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        // 追加ノード配下の該当a、文字更新の親aに適用
        pending.forEach(node => {
          pending.delete(node);
          // node自体がaかもしれないのでclosestで拾う
          const candidate = node.nodeType === 1 ? node : node.parentElement;
          const anchor = candidate?.closest?.("a");
          if (anchor) transformAnchor(anchor);
          // 配下のaもまとめて処理
          if (candidate && candidate.querySelectorAll) {
            candidate.querySelectorAll(`a[href*='${TARGET_HREF_PART}']`).forEach(transformAnchor);
          }
        });
      });
    }

    const observer = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.type === "childList") {
          m.addedNodes.forEach(n => {
            pending.add(n);
          });
        } else if (m.type === "characterData") {
          pending.add(m.target);
        } else if (m.type === "attributes" && m.attributeName === "href") {
          pending.add(m.target);
        }
      }
      scheduleProcess();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["href"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      applyToExisting();
      observeDynamic();
    });
  } else {
    applyToExisting();
    observeDynamic();
  }
})();